import BasicApiModel from "scripts/models/basicApiModel";

class OrganizationProfileModel extends BasicApiModel {
  urlRoot() {
    return `${this.apiUrlRoot}/organizations/`;
  }
}

export default OrganizationProfileModel;
